import collectionPoster from '@/assets/images/summer-haze-collection.png';







export const order = 3;

export default {
  collection_name: 'Summer Haze Collection',
  collection_desc:
    'Inspired by the soft warmth of summer light, the Summer Haze Collection features refined oak flooring with airy tones, subtle grain movement, and a calm, modern palette. Designed to brighten interiors and highlight the natural beauty of wood, each plank combines timeless elegance with the durability and craftsmanship Sakura Floors is known for.\n\nPerfect for creating light, inviting spaces, Summer Haze brings effortless warmth and contemporary style to both residential and commercial environments.',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Misty Harbor',
      sku: 'KRJ20',
      product_desc:
        'The Calm of the Coast.Where strength meets serenity. Inspired by the quiet, atmospheric mornings of a deep-water port, Misty Harbor brings a sophisticated, cool-toned foundation to the modern home. Its pale, silvery-ash hues are designed to expand your space, reflecting natural light to create an airy, open-concept feel.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Misty%20Harbor/Misty%20Harbor1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty Harbor'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Wheat',
      sku: 'KRJ21',
      product_desc:
        'The Heart of the Home. Inspired by sun-soaked fields at peak harvest, Golden Wheat is designed to bring an immediate sense of organic comfort to your living space. Its radiant, medium-honey tones act as a natural light enhancer, turning even the quietest rooms into glowing, high-energy sanctuaries.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Wheat/Golden%20Wheat1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Wheat'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Sunset Glow',
      sku: 'KRJ22',
      product_desc:
        'The warmth of the day’s end, brought indoors. Sunset Glow is designed for those who want their home to radiate a welcoming, high-energy warmth. Inspired by the deep, amber hues of a horizon at dusk, this collection features a rich, multi-dimensional palette that breathes life into every room, turning your floor into a masterpiece of natural light.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Sunset%20Glow/Sunset%20Glow1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Sunset Glow'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Ivory Grain',
      sku: 'KRJ23',
      product_desc:
        'Pure Luminosity. Ivory Grain is our most ethereal collection, designed to transform interiors into expansive, light-filled sanctuaries. With its stunningly pale, cream-and-alabaster palette, this floor acts as a canvas for modern living, reflecting every drop of natural light to create an atmosphere of pure, undisturbed serenity.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Ivory%20Grain/Ivory%20Grain1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Ivory Grain'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Maple Grove',
      sku: 'KRJ24',
      product_desc:
        'The Natural Middle. Maple Grove is designed for the homeowner who wants the best of both worlds: the brightness of a light floor and the organic warmth of natural timber. With its soft, sun-bleached oatmeal palette, this collection brings an effortless, "lived-in" elegance to any space, acting as the perfect bridge between modern cool and traditional cozy.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove1.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove2.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove3.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove4.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove5.jpeg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Maple%20Grove/Maple%20Grove1.jpeg',
        },
      ],
      product_attributes: [
        ['Color', 'Maple Grove'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Hour',
      sku: 'KRJ25',
      product_desc:
        'Eternal Warmth. Golden Hour is more than just a floor; it’s a mood. Inspired by that brief, magical moment when the sun dips low and everything turns to gold, this collection brings a permanent sense of warmth and optimism to your home. Its buttery, sun-kissed oak tones provide a radiant foundation that makes every room feel more alive.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour1.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour2.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour3.jpeg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour4.jpeg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Summer%20Haze%20Collection/Golden%20Hour/Golden%20Hour1.jpeg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Hour'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
